<style lang="less" scoped>
.upgrade_tip_wrap {
	width: 100%;
	box-sizing: border-box;
	position: relative;
	.upgrade_title {
		font-size: 14px;
		color: rgba(39, 41, 36, 1);
	}
	.upgrade_tips_content {
		margin-top: 6px;
		font-size: 12px;
		color: rgba(78, 89, 105, 1);
	}
}
</style>
<template>
	<div class="upgrade_tip_wrap">
		<div class="upgrade_title">提示</div>
		<div class="upgrade_tips_content">抱歉，当前为{{ versionText }}及以上版本功能，请升级后使用</div>
	</div>
</template>
<script>
export default {
	props: {
		isPay: {
			type: [Number, String],
			default: 2,
		},
	},
	computed: {
		versionText() {
			let obj = {
				0: '免费版',
				1: '专业版',
				2: '旗舰版',
				3: '尊享版',
				4: '电商版',
				9: '企业版',
			};
			return obj[this.isPay];
		},
	},
};
</script>
